import { addScriptToDOM } from '@/helpers/script'

export const STYLITICS_CLIENT_IDS = {
  us: 'onrunning_us',
  gb: 'onrunning_uk',
  de: 'onrunning_de',
}

export const STYLITICS_COUNTRIES_ENABLED = Object.keys(STYLITICS_CLIENT_IDS)

export const STYLITICS_TRACKING_SRC =
  'https://web-assets.stylitics.com/purchase-tracking/latest/purchase_tracking_iife.js'

export const trackStylitics = payload => {
  const targetEl = document.head
  addScriptToDOM(STYLITICS_TRACKING_SRC, { targetEl }).then(() => {
    window.StyliticsPixel(payload)
  })
}
